// extracted by mini-css-extract-plugin
export var gifts = "style-module--gifts--2c325";
export var policy = "style-module--policy--3922e";
export var reg = "style-module--reg--42f3c";